import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';
import { USE_FEDERATED_AUTH } from 'config';
import type { ApiResponse } from 'apisauce';

const createEmptyResponse = (): ApiResponse<unknown, unknown> => ({
  ok: true,
  problem: null,
  originalError: null,
  data: [],
  status: 200,
  headers: {},
  config: undefined,
  duration: 0,
});

export const apiUsers: ApiType = {
  get: {
    list: ({ query }) => api.get('/api/users', query),
    search: ({ query, vars }) =>
      api.get(stringParse('/api/users?search={0}&organizationId={1}', vars), query),
    getUsersForOrganization: ({ query, vars }) => {
      const resolved = vars?.length === 3 ? ['', ...vars] : vars;
      if (
        !resolved ||
        resolved.length < 4 ||
        resolved[2] == null ||
        String(resolved[2]).trim() === ''
      ) {
        return Promise.resolve(createEmptyResponse());
      }

      return api.get(
        stringParse(
          'api/organizations/{2}/users?search={0}&fetchAssociatedDesigners={3}',
          resolved
        ),
        query
      );
    },
    getUsersForOrganizationWithSuppliers: ({ query, vars }) => {
      const resolved = vars?.length === 3 ? ['', ...vars] : vars;
      if (
        !resolved ||
        resolved.length < 3 ||
        resolved[2] == null ||
        String(resolved[2]).trim() === ''
      ) {
        return Promise.resolve(createEmptyResponse());
      }

      return api.get(
        stringParse(
          'api/organizations/{2}/users?search={0}&fetchAssociatedSuppliers=true&status=0,1',
          resolved
        ),
        query
      );
    },
    getUsersForDirectSupplier: ({ query, vars }) =>
      api.get(stringParse('/api/organizations/{0}/users', vars), query),
    // Legacy-auth only: under federated auth the gating data comes from the Nexos
    // current-user endpoint via the login context (features/accessControl useLoggedInUser)
    // and this endpoint is never called.
    loggedInUser: () => api.get('/LoggedInUser'),
    featureFlags: () => api.get(USE_FEDERATED_AUTH ? '/api/featureflags' : '/FeatureFlags'),
  },
  put: { updateUser: ({ data, vars }) => api.put(stringParse('/api/users/{0}', vars), data) },
  post: {
    // Invite a supplier user (dl-60445 / dl-61784). Reused verbatim for "resend invite".
    inviteSupplierUser: ({ data, vars }) =>
      api.post(stringParse('/api/organizations/{0}/users', vars), data),
  },
  delete: {},
};
